import {Validator} from "../validator.abstract";
import {ApplyMoment} from "./apply-moment.enum";

export class NotEmpty extends Validator {

    public readonly applyMoment: ApplyMoment[] = [ApplyMoment.ON_INIT, ApplyMoment.ON_CHANGE];

    public isValid(value: any): string | null {
        if ([undefined, null, ``].includes(value)) {
            return `Die Angabe darf nicht leer sein`;
        }

        if (typeof value === `string` && value.length < 1) {
            return `Diese Angabe darf nicht leer sein`;
        }

        return null;
    }

}